<template>
<div class="row">
  <div class="flex xs12 sm12 lg6">
      <va-card class="xl12 " >
    
      <p class="display-3 text-center">   Evaluación</p>
      <hr>
        <div class="row flex">

          <div class="md12 xl12">
          
              <va-data-table
              :fields="fields"
              :data="allAvaliacoes"
              hoverable
              no-pagination
              > 
                  <template slot="marker" slot-scope="props">
                    <va-icon name="fa fa-circle" :color="props.rowData.color" size="8px" />
                  </template>

                  <template  slot="actions" slot-scope="props">
                    <va-button  small color="blurple" @click="Avaliacoes_realizadas(props.rowData)" class="ma-0">
                     {{$t('arealuno.Ver')}}
                    </va-button>
                 


                  </template>
                  
            </va-data-table>

          </div>


        </div>

    
     </va-card>
  </div>
  <div class="flex xs12 sm12 lg6">
    <va-card>
      <p class="display-3 text-center">   Visualizar</p>
      <hr>
      <div class="tamanho_div" >

          <!-- recado do aluno -->
        <div class="flex xs12 sm12 lg12 xl12">
          <div class="va-card"
          ><div class="va-card__stripe" style="background: rgb(44, 130, 224);">
            </div><!---->
            <div class="va-card__header">
              <div class="va-card__header-inner">
                <div class="va-card__header-title" style="color: rgb(44, 130, 224);">
                      Recado Importante!
                </div>
              <div class="va-card__header-actions">
            </div>
          </div>
          </div>
                <div class="va-card__body">
            Estimados alumnos: <br>
•	La evaluación tiene un tiempo límite de 30 minutos.<br>
•	Cuenta con 2 (dos) intentos y se seleccionará el de mayor puntaje. <br>
•	Para que su respuesta sea válida debe hacer clic en el botón “Guardar”.<br>
•	Al responder a todos los cuestionarios debe hacer clic en “Finalizar”.<br>
•	Cuenta con 5 (cinco) días corridos para realizar la evaluación.<br>
•	Antes de iniciar el examen asegúrese de contar con buena conexión a internet. <br>
•	Ante cualquier duda o inconveniente técnico por favor póngase en contacto escribiendo a informatica@central.edu.py o al Whatsapp de la Universidad.
              </div>
          </div>
        </div>
        <!-- termino recado aluno -->



        <!-- Nome da materia prova inicio -->
        <div v-if="avaliacao" class="flex xs12 sm12 lg12 xl12">
          <div class="va-card mb-0">
            <div class="va-card__stripe"  style="background: rgb(100, 000, 000);">
            </div><!----><!---->
            <div class="va-card__body va-card__body--padding-top">
                {{avaliacao.nome_curso}} - 
              {{avaliacao.nome}}
                
            </div>
          </div>
        </div>
        <!-- Nome materia prova fim -->



        <!-- inicio nova avaliacao -->
        <div v-if="avaliacao" class="flex xs12 sm12 lg12 xl12">
          <div class="va-card mb-0">
            <div class="va-card__stripe" style="background: rgb(255, 194, 0);">
            </div><!----><!---->

            <div v-if="liberar_data" class="va-card__body va-card__body--padding-top">
                    Clic aquí para iniciar el examen:
                    <va-button   small color="blurple" @click="Nova_tentativa()" class="ma-0">
                    Ingresar
                    </va-button>
            </div>



          </div>
        </div>
        <!-- termino nova avaliacao -->

          <!-- Perguntas -->
             <va-data-table
             v-if="avaliacao"
              :fields="avalia"
              :data="getAvaliacoesRealizadas"
              hoverable
              no-pagination
              > 
                  <template slot="marker" slot-scope="props">
                    <va-icon name="fa fa-circle" :color="props.rowData.color" size="8px" />
                  </template>
                <!--  -->
                  <template  v-if="liberar_data" slot="actions" slot-scope="props">
                    <va-button  v-if="props.rowData.status == 1"  small color="blurple" @click="abrirModal(props.rowData)" class="ma-0">
                     Empezar
                    </va-button>
                 
                  </template>
                  <!-- <template  v-if="liberar_data == false" slot="actions" slot-scope="props">
                    <va-button  small color="blurple" @click="abrirModal(props.rowData)" class="ma-0">
                     Respostas
                    </va-button>
                 
                  </template> -->
                  
            </va-data-table>
          <!-- Fim perguntas -->


            <!-- Inicio Modal -->
          <div class="modal text-center" v-show="showModal" >
            <div class="modal-wrapper text-center">
              <div class="modal-container scroll text-center">
                <content select="modal-header">
                  <div class="modal-header">
                    
                    <h3 class="text-right ">
                       
                      {{horaImprimivel}}
                      <va-button class="text-right"  v-on:click="finalizar()"  color="danger"> Finalizar</va-button>
                    </h3>
                  </div>
                </content>
                <hr>
           
              <!-- Inicio Tabela  perguntas -->

               <div  class="flex md12 va-card center">
                    <div class="row flex text-center">

                            <div  v-for="(lista_pergunta,index) in getPerguntasRealizar" :key="index" v-on:click="trocar_pergunta(lista_pergunta)"  :class="[lista_pergunta.status_respondida == 0 ? vermelho : '',lista_pergunta.status_respondida == 1 ? verde : '']" title="Inicio" class="flex flex-center mb1 icon-grid-container edit" style="flex-direction: column;">
                              <div  class="vuestic-icon mb-1 pt-1">
                                Pregunta - {{lista_pergunta.numero_pergunta}}
                                <!-- {{lista_pergunta.status_respondida}} -->
                              </div>
                            </div>
                       
                    </div>
               </div>

              <div class="text-center scrolll">

                  <!-- Inicio pergunta -->
                  <!-- Aqui o foreach das perguntas -->
                 <div   class="text-center">
                    <div class="  flex md12 sm12 xs12 lg10 offset--md1 " >
                           <!-- recado do aluno -->
                            <div class="va-card  ">
                                <div class="va-card__stripe" style="background: rgb(44, 130, 224);"> </div>
                                <div class="va-card__header">
                                  <div class="va-card__header-inner">
                                      <div class="va-card__header-title" style="color: rgb(44, 130, 224);">
                                          Pergunta - {{numero_pergunta}}
                                      </div>
                                      <div class="va-card__header-actions"></div>
                                  </div>
                                </div>
                                <div class="va-card__body ">
                                  {{pergunta.titulo}}-
                                  {{pergunta.status_respondida}}
                                </div>
                            </div>
                          <!-- termino recado aluno -->
                    </div>
                    <div class="row">
                      <div class="flex md12 sm12 xs12 lg12">
                        <input type="radio"  value="A" v-model="pergunta.resposta">
                        <label for="one"> A </label>
                        <input  disabled    class="tamanho_imput "  type="text"  value="" v-model="pergunta.a">
                        <br>
                        <input type="radio"  value="B" v-model="pergunta.resposta">
                        <label for="two"> B </label>
                        <input disabled class="tamanho_imput" type="text"  value="" v-model="pergunta.b">
                        <br>
                        <input v-if="pergunta.c" type="radio"  value="C" v-model="pergunta.resposta">
                        <label v-if="pergunta.c" for="two"> C </label>
                        <input v-if="pergunta.c" disabled class="tamanho_imput" type="text"  value="" v-model="pergunta.c">
                        <br>
                        <input  v-if="pergunta.d" type="radio" value="D" v-model="pergunta.resposta">
                        <label v-if="pergunta.d" for="two"> D </label>
                        <input v-if="pergunta.d" disabled class="tamanho_imput" type="text"  value="" v-model="pergunta.d">
                        <br>
                        <input v-if="pergunta.e" type="radio"  value="E" v-model="pergunta.resposta">
                        <label v-if="pergunta.e" for="two"> E </label>
                        <input v-if="pergunta.e" disabled class="tamanho_imput" type="text"  value="" v-model="pergunta.e">
               
                      </div>
                    </div>

             
                    <hr>
                   
                </div>
                <!-- Fim Pergunta -->

                 <va-button class="text-center"  v-on:click="salvar_pergunta()"  color="dark"> Guardar</va-button>
                  
           </div>

                <!-- Fim Tabela -->
          
                <!-- <div class="text-center">
                    <va-button @click="showModal = false"  color="info" >Fechar</va-button>
                </div> -->
              </div>
            </div>
          </div>
          <!-- Fim Modal -->

          
       
    </div>
    </va-card>
  </div>

</div>
</template>

<script>

import pdf from 'vue-pdf'
export default {
  name: 'evaluacion',
   components: {
     
    },

  data () {
      return {
        verde:'cor_verde',
        vermelho:'cor_vermelha',
        showModal: false,
        avaliacoes:'',
        avaliacao:'',
        tempo:'1800',
        horaImprimivel:0,
        novo :true,
        numero_pergunta :'',
        id_pergunta :'',
        tentativa_id:'',
        pergunta: {
          titulo: '',
          a: '',
          b: '',
          c: '',
          d: '',
          e: '',
          resposta: '',
          status_respondida:'',
        },
    
      }
    },
    created(){
      this.all();
      
    },
  computed: {
    
    fields () {
        return [{
          name: '__slot:marker',
          width: '30px',
          dataClass: 'text-center',
        },
        {
          name: 'nome_curso',
          title: this.$t('arealuno.Nome'),
        }, {
          name: 'nome',
          title: this.$t('arealuno.Nome'),
        }, {
          name: 'data_abertura',
        //  dataClass: 'text-center',
          title: this.$t('arealuno.Data_inicio'),
         
        }, {
          name: 'data_encerramento',
         // dataClass: 'text-center',
          title: this.$t('arealuno.Data_termino'),
         
        },
          {
        name: '__slot:actions',
        dataClass: 'text-center',
        }]
    },
    avalia () {
        return [{
          name: '__slot:marker',
          width: '30px',
          dataClass: 'text-center',
        }, {
          name: 'data_abertura',
        //  dataClass: 'text-center',
          title: this.$t('arealuno.Data_inicio'),
         
        }, {
          name: 'conceito',
         // dataClass: 'text-center',
          title: 'Conceito',
         
        },
          {
        name: '__slot:actions',
        dataClass: 'text-center',
        }]
    },

    liberar_data(){
      
        var data = new Date(),
        dia  = data.getDate().toString().padStart(2, '0'),
        mes  = (data.getMonth()+1).toString().padStart(2, '0'), //+1 pois no getMonth Janeiro começa com zero.
        ano  = data.getFullYear();
        var str_data = ano + '-' +mes + '-' + dia + ' 00:00:00';
  
        if( this.avaliacao.data_encerramento >= str_data ){
         
          return true

        }else{
          return false
        }

    },

      allAvaliacoes(){ return this.$store.state.avaliacao.allAvaliacoes; },
      getAvaliacoesRealizadas(){ return this.$store.state.avaliacao.getAvaliacoesRealizadas; },
      getPerguntasRealizar(){ return  this.$store.state.avaliacao.allOfertaPerguntas; },
  
  },

  methods: {

    

   async salvar_pergunta(){

     let salvar = {
       resposta: this.pergunta.resposta,
       ead_avaliacao_aluno_id: this.tentativa_id,
       ead_oferta_pergunta_id: this.id_pergunta

     }
     // console.log(salvar)
     await this.$store.dispatch('addRespostaPergunta',salvar)
     .then(() => {
      alert('Salvo')
      })
      .catch((erro) => {
         alert(erro)
      })
  
    },

   async trocar_pergunta(value){
    
     
     this.numero_pergunta = value.numero_pergunta // trocar pelo numero sequencial
     this.id_pergunta = value.id

     let enviar = {
         tentativa_id: this.tentativa_id,
         pergunta_id: value.id
       }
      await this.$store.dispatch('getPergunta',enviar)

      .then(() => {
      
      })
      .catch(() => {
         
      }).finally(()=>  
     // console.log(this.$store.state.avaliacao.getPergunta),
    
        this.pergunta= {
          titulo: this.$store.state.avaliacao.getPergunta.nome,
          a: this.$store.state.avaliacao.getPergunta.a,
          b: this.$store.state.avaliacao.getPergunta.b,
          c: this.$store.state.avaliacao.getPergunta.c,
          d: this.$store.state.avaliacao.getPergunta.d,
          e: this.$store.state.avaliacao.getPergunta.e,
          resposta: this.$store.state.avaliacao.getPergunta.resposta,
          status_respondida: this.$store.state.avaliacao.getPergunta.status_respondida,
        },
      //  console.log(this.pergunta)
      )

    },

   async Nova_tentativa () {

       let  dados = {
        avaliacao_id: this.avaliacao.id,
        aluno_id: this.$store.state.alunos.get_aluno.id

     }
      
      await this.$store.dispatch('addTentativa',dados)
      .then(() => {
      
      })
      .catch(() => {
         
        }).finally(()=>  
        this.all()
        
        )

    },

   async abrirModal(value){
    this.tentativa_id = value.id

    this.showModal = true
    await this.$store.dispatch('InserirTempoTentativa',value.id)
    await this.$store.dispatch('allOfertaPerguntasAvaliacao',value)
    this.Iniciar_tentativa()
    this.all()
    
    },

    all() {

      this.$store.dispatch("allAvaliacoesCurso",this.$store.state.alunos.get_aluno.id)
      this.Avaliacoes_realizadas(this.avaliacao)

    },

    Avaliacoes_realizadas(value) {

    
    this.avaliacao = value;

    let  dados = {
        avaliacao_id: value.id,
        aluno_id: this.$store.state.alunos.get_aluno.id

     }
      this.$store.dispatch("getAvaliacoesRealizadas", dados)
     
    },

    Iniciar_tentativa(){
      // Define que a função será executada novamente em 1000ms = 1 segundo
      //  setTimeout(this.Contador_tempo, 1000);

            //setTimeout(this.tempo = 10, 2000)
      setInterval(this.Contador_tempo, 1000);
      
     
    },

    finalizar(){

        this.showModal = false
        this.all()

       this.$router.push({ name: 'alunos/matriculas' })
      

    },

    Contador_tempo(){

        // Se o tempo não for zerado
    if ((this.tempo - 1) >= -1) {

        // Pega a parte inteira dos minutos
        var min = parseInt(this.tempo / 60);
        // Calcula os segundos restantes
        var seg = this.tempo % 60;

        // Formata o número menor que dez, ex: 08, 07, ...
        if (min < 10) {
            min = "0" + min;
            min = min.substr(0, 2);
        }
        if (seg <= 9) {
            seg = "0" + seg;
        }

        // Cria a variável para formatar no estilo hora/cronômetro
        this.horaImprimivel = '00:' + min + ':' + seg;
       
        // diminui o tempo
        this.tempo--;

        // Quando o contador chegar a zero faz esta ação
    } 
    else {

      if (this.showModal) {
        this.showModal = false
        this.all()
        this.$router.push({ name: 'alunos/matriculas' })
      }
      
      
    }

    },

  
 
  },
   
}
</script>

<style lang="scss" scoped>
.scrolll{
  overflow-y: scroll;
  max-height: 400px;

}
.scroll{
  overflow-y: scroll;
  max-height: 900px;

}
.cor_verde
{
  
  background-color: #3CBC8D;
  color: white;

}
.cor_vermelha
{
  
  background-color: rgb(240, 18, 18);
  color: white;

}

.tamanho_video
{
 width: 100%;
  height: 100%;
}
.tamanho_div
{
 width: 100%;
  height: 900px;
}

.borda 
{
  border-right: 1px solid black;
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 1s ease;
}

.slide-fade-enter /*.slide-fade-leave-to*/
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}


// daqui para baixo é do modal
 .modal {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .5s ease;
  
  &-wrapper {
   // display: table-cell;
    vertical-align: middle;
  }
  
  &-container {
    background: #fff;
    width: 90%;
    min-height: 50%;
     max-height: 70%;
    border-radius: 5px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0);
  //  transition: all .3s ease;
    margin:  auto;
    margin-top: 30px;
    padding: 20px 30px;
  }
  
  &-footer {
    margin-top: 15px;
  }
  
  &-enter, &-leave {
    opacity: 0;
  }
  
  &-enter &-container,
  &-leave &-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
}

</style>